export default{
    layoutStyle:{ minHeight: '90vh' },
    contentStyle:{ padding: '0px 15px 15px 15px' },
    parentPath:{
        name:'',
        path:''
    }
};